module.exports = __webpack_public_path__ + "static/media/pen-select.1d493d06.svg";